import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { WHEN_CASES } from '../data/whenCases';
import SectionHead from './SectionHead';
import layout from '../styles/layout.module.css';
import styles from './WhenSection.module.css';

const WhenSection: React.FC = () => {
  const { elementRef, isVisible } = useScrollAnimation<HTMLDivElement>();

  return (
    <section id="when" className={layout.section} aria-labelledby="when-title">
      <div
        ref={elementRef}
        className={`${layout.wrap} ${layout.sectionInner} slide-up ${isVisible ? 'visible' : ''}`}
      >
        <SectionHead
          eyebrow="WHEN"
          title="こんなとき、ご相談ください。"
          titleId="when-title"
          lead="大きな案件でなくて構いません。「これは誰に聞けばいいのか」という段階から、一緒に整理します。"
        />
        <ul className={styles.list}>
          {WHEN_CASES.map((item) => (
            <li key={item.situation} className={styles.row}>
              <p className={styles.situation}>{item.situation}</p>
              <p className={styles.response}>{item.response}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default WhenSection;
